import React, { useRef, useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { paySaleReceivables } from "../../../../services/SaleService";
import { toast } from "react-toastify";
import currencyBRFormat from "../../../../util/CurrencyUtils";

const FormaPagamentoVendaAPrazoModal = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const inputPaymentMethod = useRef("");

  function close() {
    props.setPaymentMethodModalOpen(false);
  }

  function paySales(e) {
    e.preventDefault();
    const execute = window.confirm(
      `Você tem certeza que deseja dar baixa ${props.selectedCustomer == null
        ? "nesta venda a prazo"
        : `nas vendas a prazo do cliente ${props.selectedCustomer.label}`
      } ?`
    );

    if (execute) {
      setLoading(true);
      const data = {
        salesIds: props.saleIds
          ? [props.saleIds]
          : props.sales.map((s) => s.id),
        paymentMethod: inputPaymentMethod.current.value,
      };

      paySaleReceivables(data)
        .then((response) => {
          toast.success(response);
          props.listSales();
          close();
        })
        .catch((error) =>
          toast.error("Não foi possivel dar baixa nas vendas a prazo")
        )
        .finally(() => setLoading(false));
    }
  }

  return (
   <Modal 
  isOpen={isOpen} 
  toggle={close} 
  backdrop="static" 
  centered 
  contentClassName="border-0 rounded-4 shadow-lg"
>
  <ModalHeader toggle={close} className="border-bottom-0 pb-0 pt-4 px-4">
    <span className="fw-bold text-primary">Liquidar Vendas a Prazo</span>
  </ModalHeader>

  <form onSubmit={paySales}>
    <ModalBody className="p-4">
      {/* Card Informativo do Cliente */}
      <div className="bg-light p-3 rounded-3 mb-4 border">
        <div className="d-flex align-items-center mb-2">
          <i className="fas fa-user-circle me-2 text-primary"></i>
          <span className="text-muted small fw-bold text-uppercase">Cliente</span>
        </div>
        <div className="h5 fw-bold text-dark mb-0">
          {props.sales[0]?.customer?.name || "Cliente não identificado"}
        </div>
      </div>

      {/* Destaque do Valor Total */}
      <div className="text-center mb-4 py-3 border-bottom border-top">
        <div className="text-muted small fw-bold text-uppercase mb-1">Total a Receber</div>
        <div className="display-6 fw-bold text-success">
          {currencyBRFormat(
            props.sales
              .map((s) => s.total)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
          )}
        </div>
      </div>

      {/* Seleção de Pagamento */}
      <div className="mb-2">
        <label className="form-label fw-bold text-muted small text-uppercase">
          <i className="fas fa-cash-register me-1"></i> Forma de Pagamento
        </label>
        <select
          id="paymentMethod"
          ref={inputPaymentMethod}
          className="form-select form-select-lg border-2 shadow-sm fw-bold text-dark rounded-3"
          required
        >
          <option value="PIX">Pix</option>
          <option value="MONEY">Dinheiro</option>
          <option value="CREDIT">Cartão de Crédito</option>
          <option value="DEBIT">Cartão de Débito</option>
        </select>
      </div>
    </ModalBody>

    <ModalFooter className="border-top-0 p-4 pt-0">
      {!loading ? (
        <div className="d-flex w-100 gap-2">
          <button 
            type="submit" 
            className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm"
          >
            <i className="fas fa-check-circle me-2"></i> Concluir Baixa
          </button>
          
          <button 
            type="button" 
            onClick={close} 
            className="btn btn-outline-danger btn-lg rounded-3 border-2"
          >
            Cancelar
          </button>
        </div>
      ) : (
        <div className="d-flex justify-content-center w-100 py-2">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Processando...</span>
          </div>
        </div>
      )}
    </ModalFooter>
  </form>
</Modal>
  );
};
export default FormaPagamentoVendaAPrazoModal;
